<template>
    <div class="course">
        <Top :title="title"></Top>
        <div class="s_banner">
            <img src="../../../assets/images/s_banner_2.jpg" alt=""/>
        </div>
        <Column title="年级分类">
            <Subject :list="showClassList"></Subject>    
        </Column>
        <div class="no-data-pad" v-if="list.length === 0"></div>
        <div class="line" v-if="list.length > 0"></div>
        <Column title="最新课程" v-if="list.length > 0">
            <ImgList :list="list"></ImgList>
        </Column>
        <Loading :show="isUa && isLoading"></Loading>
    </div>
</template>

<script>
import jsonp from 'jsonp'
import Top from './module/top'
import Subject from './module/subjectList'
import ImgList from './module/imgList'
import Column from "../column"
import Loading from "../../loading"
import util from '../../../util'

export default{
    name: 'Course',
    data(){
        return{
            title: '',
            name: this.$route.params.title,
            sortid: this.$route.params.sortid,
            isUa: window.navigator.userAgent.indexOf('ZgApp') < 0,
            isLoading: false,
            list: [],
            primaryList: [
                {
                    link: `#/classifiy/${encodeURI('一年级')}/50946`,
                    gradeName: '一年级'
                },
                {
                    link: `#/classifiy/${encodeURI('二年级')}/50947`,
                    gradeName: '二年级' 
                },
                {
                    link: `#/classifiy/${encodeURI('三年级')}/50948`,
                    gradeName: '三年级'
                },
                {
                    link: `#/classifiy/${encodeURI('四年级')}/50949`,
                    gradeName: '四年级' 
                },
                {
                    link: `#/classifiy/${encodeURI('五年级')}/50950`,
                    gradeName: '五年级'
                },
                {
                    link: `#/classifiy/${encodeURI('六年级')}/50951`,
                    gradeName: '六年级' 
                }
            ],
            juniorHighList: [
                {
                    link: `#/classifiy/${encodeURI('初一')}/50952`,
                    gradeName: '初一'
                },
                {
                    link: `#/classifiy/${encodeURI('初二')}/50953`,
                    gradeName: '初二' 
                },
                {
                    link: `#/classifiy/${encodeURI('初三')}/50954`,
                    gradeName: '初三'
                }
            ],
            highSchoolList: [
                {
                    link: `#/classifiy/${encodeURI('高一')}/50955`,
                    gradeName: '高一'
                },
                {
                    link: `#/classifiy/${encodeURI('高二')}/50956`,
                    gradeName: '高二' 
                },
                {
                    link: `#/classifiy/${encodeURI('高三')}/50957`,
                    gradeName: '高三'
                }
            ]
        }
    },
    computed:{
        showClassList(){
            let name = this.$route.params.title;
            let list = [];
            switch(name){
                case '小学教育':
                    this.title = '小学教育';
                    list = this.primaryList;
                    break;
                case '初中教育':
                    this.title = '初中教育';
                    list = this.juniorHighList;
                    break;
                case '高中教育':
                    this.title = '高中教育';
                    list = this.highSchoolList;
                    break;
            }
            return list
        }
    },
    created(){
        this.getData(this.name);
    },
    mounted(){
        util.jumpLink();
        this.getStatistPv();
    },
    methods:{
        getData(name){
            let idArr = '';
            // switch(name){
            //     case '小学教育':
            //         idArr = [50946,50947,50948,50949,50950,50951].join(',');
            //         break;
            //     case '初中教育':
            //         idArr = [50952,50953,50954].join(',');
            //         break;
            //     case '高中教育':
            //         idArr = [50955,50956,50957].join(',');
            //         break;
            //     default:
            //         idArr = this.$route.params.sortid;
            //         break;
            // }
            // this.isLoading = true;           
            // jsonp(`https://v.gxnews.com.cn/?c=json&a=course_list&sortids=${idArr}&limit=100`, {} , (err, data) => {
            //     if (err) {
            //         console.error(err.message);
            //     } else {
            //         this.isLoading = false;
            //         this.list = data.courselist;
            //     }
            // })
            switch(name){
                case '小学教育':
                    idArr = 'primarySchool';
                    break;
                case '初中教育':
                    idArr = 'juniorHighSchool';
                    break;
                case '高中教育':
                    idArr = 'highSchool';
                    break;
                default:
                    idArr = this.$route.params.sortid;
                    break;
            }
            this.isLoading = true;  
            this.axios.get(`/data/${idArr}.json?t=${Math.round(new Date().getTime()/100000)}`).then((res) => {
                this.isLoading = false;
                this.list = res.data.courselist;
            })
        },
        getStatistPv(){
            jsonp(`https://dcy.gxnews.com.cn/insert.php?myurl=http%3a%2f%2fbyte.gxnews.com.cn%2fzg%2f%23%2fcourse%2f${this.name}&tag=zgapp&t=${Math.random()}`, {} , (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log('请求成功');
                }
            })   
        }
    },
    components:{
        Top,
        Subject,
        ImgList,
        Column,
        Loading    
    }
}
</script>

<style lang="less" scoped>
    .course{
        padding-top: 1rem;
        .s_banner{
            margin-bottom: 0.35rem;
            img{
                width: 100%;
            }
        }
        .line{
            height: 0.25rem;
            margin: 0.2rem 0 0.3rem 0;
            background: #f3f3f3;
        }
        .no-data-pad{
            padding-bottom: 1.5rem;
        }
    }             
</style>   